export default "__VITE_ASSET__Yw8P$nuY__"